import { Component, OnInit } from '@angular/core';
import { UsersListComponent } from '../../lists/users-list/users-list.component';

@Component({
  selector: 'app-developer-application-users',
  templateUrl: './developer-application-users.component.html',
  styleUrls: ['./developer-application-users.component.scss'],
  standalone: true,
  imports: [UsersListComponent],
})
export class DeveloperApplicationUsersComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
